import * as BlogApi from "api/VideoBlogApi";
import * as ActionTypes from "constants/ActionTypes";
import { toaster } from "utils/toaster";
import { requestError } from "utils/request";

export function loadBlogDetails(blogId) {
    return (dispatch) => {
        BlogApi.loadBlogDetails(blogId)
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_PAGE_DETAILS_LOADED,
                    blog: res.body,
                });
            })
            .catch((err) => {
                requestError(err, "Error loading video blog page details");
            });
    };
}

export function getBlogDownload(blogId, formData) {
    return (dispatch) => {
        BlogApi.getBlogDownload(blogId, formData)
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_DOWNLOAD_SUCCESS,
                    download: res.body,
                });
            })
            .catch((err) => {
                requestError(err, "Error loading video blog page details");
            });
    };
}

export function loadBlogPages() {
    return (dispatch) => {
        BlogApi.loadBlogPages()
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_PAGES_LOADED,
                    blogs: res.body,
                })
            }).catch((err) => {
                requestError(err, "Error loading video blog pages");
            });
    }
}

export function loadContactLists() {
    return (dispatch) => {
        BlogApi.loadContactLists()
            .then((res) => {
                dispatch({
                    type: ActionTypes.CONTACT_LISTS_LOADED,
                    lists: res.body,
                })
            }).catch((err) => {
                requestError(err, "Error creating promo page");
            });
    }
}

export function loadBlogPage(blogId) {
    return (dispatch) => {
        BlogApi.loadBlogPage(blogId)
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_PAGE_LOADED,
                    blog: res.body,
                })
            }).catch((err) => {
                requestError(err, "Error loading video blog pages");
            });
    }
}

export function updateBlogPage(data, posterId) {
    return (dispatch) => {
        BlogApi.updateBlogPage(data)
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_PAGE_UPDATED,
                    blog: res.body,
                    posterId,
                });
                toaster.success("Video Blog Page Updated!");
            }).catch((err) => {
                requestError(err, "Error updating video blog page");
            });
    }
}

export function createBlogPage(blogData, posterId) {
    return (dispatch) => {
        BlogApi.createBlogPage(blogData)
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_PAGE_CREATED,
                    blog: res.body,
                    posterId,
                });
                toaster.success("Video Blog Page Created!");
            }).catch((err) => {
                let errorMessage = "Error creating video blog page";
                
                if (err.response && err.response.body) {
                    const errorMessages = err.response.body;
                    errorMessage = "";

                    for (const field in errorMessages) {
                        if (errorMessages.hasOwnProperty(field)) {
                            errorMessage += `${field}: ${errorMessages[field].join(', ')}\n`;
                        }
                    }
                }

                requestError(err, errorMessage);
            });
    }
}

export function cloneBlogPage(blogId) {
    return (dispatch) => {
        BlogApi.cloneBlogPage(blogId)
            .then((res) => {
                dispatch({
                    type: ActionTypes.BLOG_PAGE_CREATED,
                    blog: res.body,
                })
                toaster.success("Video Blog Page Duplicated!");
            }).catch((err) => {
                requestError(err, "Error creating video blog page");
            });
    }
}

export function clearPosterSuccess(posterId) {
    return (dispatch) => {
        dispatch({
            type: ActionTypes.CLEAR_SUCCESS,
            posterId,
        });
    }
}
